import React from "react";
import { Row, Col, Typography, Icon } from "antd";
// import moment from "moment"

import totalUser from "media/total_users.png";
import newRegisteredUser from "media/new_registered_user_icon.png";
import promosGenerated from "media/promos_generated_icon.png";
import vouchersGenerated from "media/vouchers_generated_icon.png";

const { Text } = Typography;
// const { RangePicker } = DatePicker;

function UserDataCard(props) {
    return (
        <Row
            type='flex'
            gutter={[12, 12]}
            align='middle'
            style={{
                background: "#FFFFFF",
                border: "1px solid #F2F2F2",
                boxSizing: "border-box",
                padding: "10px 20px",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
            }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{alignSelf:"center" , padding:"6px"}}>
                    <img
                        src={props.imgsrc}
                        style={{
                            width: "40px",
                            height: "40px",
                        }}
                        alt={"Total users till date illustration"}
                    />
                </div>
                <div style={{ padding:"6px"}}>
                    <Text style={{ fontSize: "20px", color: "black", fontWeight: "bold" }}>
                        {props?.data?.total_customers}
                    </Text>
                    <br />
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#747474",
                        }}>
                        {props.text}
                    </Text>
                </div>
            </div>
            <div style={{ fontSize: "21px" , marginRight:"10px" }}>
                <div>
                    <Icon type='apple' theme='filled'/>
                    <Text style={{paddingLeft:"8px"}}>{props?.data?.ios}</Text>
                </div>
                <div>
                    <Icon type='android' theme='filled' style={{color:"#fec708"}}/>
                    <Text style={{paddingLeft:"8px"}}>{props?.data?.android}</Text>
                </div>
            </div>
        </Row>
    );
}
function DataCard(props) {
    return (
        <Row
            type='flex'
            gutter={[12, 12]}
            align='middle'
            style={{
                background: "#FFFFFF",
                border: "1px solid #F2F2F2",
                boxSizing: "border-box",
                padding: "10px 20px",
                borderRadius: "8px",
            }}>
            <Col>
                <img
                    src={props.imgsrc}
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    alt={"Total users till date illustration"}
                />
            </Col>
            <Col>
                <Text style={{ fontSize: "20px", color: "black", fontWeight: "bold" }}>{props.data}</Text>
                <br />
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#747474",
                    }}>
                    {props.text}
                </Text>
            </Col>
        </Row>
    );
}

export default function Releaseanalytics(props) {
    const cardDetails = [
        //{
        //imgSrc: totalUser,
        //text: "Total Users",
        //data: props.loading ? "..." : props.data?.total_customers,
        //},
        // {
        // 	imgSrc: newRegisteredUser,
        // 	text: "New Registered Users",
        // 	data: props.loading ? "..." : props.data?.newRegisteredUsers,
        // },
        {
            imgSrc: promosGenerated,
            text: "Promos Generated",
            data: props.loading ? "..." : props.data?.promos_generated,
        },
        {
            imgSrc: vouchersGenerated,
            text: "Vouchers Generated",
            data: props.loading ? "..." : props.data?.vouchers_generated,
        },
    ];

    return (
        <React.Fragment>
            <Row type='flex' align='middle' justify='space-between'>
                <Text
                    style={{
                        fontWeight: "bold",
                        color: " #181818",
                        fontSize: "18px",
                        lineHeight: "24px",
                    }}>
                    Analytics
                </Text>
            </Row>
            <Row
                type='flex'
                gutter={[32, 32]}
                style={{
                    marginTop: "0px",
                }}>
                <Col style={{ flexGrow: 1, flexBasis: 0 }}>
                    <UserDataCard imgsrc={totalUser} text={"Total Customers"} data={props.data} />
                </Col>
                {cardDetails.map((cardDetail, index) => (
                    <Col key={index} style={{ flexGrow: 1, flexBasis: 0 }}>
                        <DataCard imgsrc={cardDetail.imgSrc} text={cardDetail.text} data={cardDetail.data} />
                    </Col>
                ))}
            </Row>
        </React.Fragment>
    );
}
